
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/clickThrough",
      function () {
        return require("private-next-pages/clm/clickThrough/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clm/clickThrough"])
      });
    }
  